module.exports = __webpack_public_path__ + "img/bg_2.791f8d4a.jpg";